import React, { Component } from 'react';
import Navigation from 'containers/Navigation';
import MainMenu from 'components/MainMenu';
import AuthMenu from 'components/MainMenu/AuthMenu';
import Userinfo from 'components/MainMenu/Userinfo';
import UserSticky from 'components/MainMenu/UserinfoSticky';

export default class MainNav extends Component {
  render() {
    const { name, role, history } = this.props.user;
    const isAuth = name !== null && role > 0;

    if (!isAuth) return null;

    return (
      <Navigation>
        <UserSticky isAuth={isAuth} history={history} />
        <MainMenu show={isAuth} role={role} />
        <AuthMenu isAuth={isAuth} history={history} />
        <Userinfo show={isAuth} />
      </Navigation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/MainNav.js